import React from 'react';
import FormControl from '@mui/material/FormControl';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import MailIcon from '@mui/icons-material/Mail';
import Paper from '@mui/material/Paper';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CloseIcon from '@mui/icons-material/Close';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
//import Ajax from './Ajax';
import {Owner} from './Inc';

interface PersonMenuProps {
	isOpen:boolean,
    close():void,
	logout():void,
	owner:Owner,
}

const PersonMenu:React.FC<PersonMenuProps> = (props)=> {
	//const defaultStates = {
	//	owners: [] as Owner[],
	//	isLoading: true,
	//};
	//const [states,setStates] = useState(defaultStates)

	//const load = ()=>{
    //    Ajax.send("profile/list",{customer_id:props.owner.customer.customer_id},(res:any)=>{
    //        if( res.ok ){
	//			let owners = [] as Owner[];
	//			for( let i=0; i<5; i++ ){
	//				owners.push(Inc.defaultOwner());
	//			}
	//			for( let i=0; i<res.owners.length; i++ ){
	//				owners[ res.owners[i].switch_id-1 ] = res.owners[i];
	//			}
    //            setStates({...states,"isLoading":false,"owners":owners})
    //        }
    //    });		
	//}

	//useEffect(()=>{
	//	if( props.isOpen ){
	//		load();
	//	} else {
	//		setStates(defaultStates);			
	//	}
	//},[props.isOpen]);

	if( !props.isOpen ){
		return (null);
	}
	return (
		<div style={{position:"fixed",top:"2.5em",right:"10px",maxWidth:"300px",minWidth:"200px",zIndex:9000}}>
			<ClickAwayListener onClickAway={props.close}>
				<Paper id="menu-list-grow" style={{paddingTop:"0.20em"}}>
					<div className="personMenu">
						<h3>会員情報</h3>
						<List className="personData">
							{props.owner.customer.name==="" ? (
							<ListItem>
								<ListItemIcon style={{marginRight:'-1em'}}><AccountBoxIcon/></ListItemIcon>
								<ListItemText primary="名前登録なし"/>
							</ListItem>
							):(
							<>
							<ListItem>
								<ListItemIcon style={{marginRight:'-1em'}}><AccountBoxIcon/></ListItemIcon>
								<ListItemText primary={props.owner.customer.name}/>
							</ListItem>
							<ListItem>
								<ListItemIcon style={{marginRight:'-1em'}}><MailIcon/></ListItemIcon>
								<ListItemText primary={props.owner.customer.mail}/>
							</ListItem>
							</>
							)}
						</List>
					</div>
					<Box style={{padding:'1em'}}>
						<FormControl fullWidth={true}>
							<Button variant="outlined" color="primary" onClick={props.logout}>ログアウト</Button>
						</FormControl>
					</Box>
					<div style={{backgroundColor:"#EEEEEE",textAlign:"center"}}>
						<Button onClick={props.close} color="primary" style={{width:"100%"}} startIcon={<CloseIcon/>}>閉じる</Button>
					</div>
				</Paper>
			</ClickAwayListener>
		</div>
	);
}

export default PersonMenu;
